import { render, staticRenderFns } from "./ChannelBreakdown.vue?vue&type=template&id=c4c32f16&scoped=true"
import script from "./ChannelBreakdown.vue?vue&type=script&lang=js"
export * from "./ChannelBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ChannelBreakdown.vue?vue&type=style&index=0&id=c4c32f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c32f16",
  null
  
)

export default component.exports